import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function LeaveIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="14.274" height="13.288" viewBox="0 0 14.274 13.288" {...props}>
      <defs>
        <style>
          {`.cls-4{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.75px}`}
        </style>
      </defs>
      <g id="Group_5965" transform="translate(-799.619 -909.107)">
        <g id="Group_5817" transform="translate(803.933 913.12)">
          <path id="Line_457" d="M0 0L7.231 0" class="cls-4" transform="translate(1.061 2.631)"/>
          <path id="Path_6435" d="M816.356 915.015l2.634 2.634-2.634 2.627" class="cls-4" transform="translate(-809.905 -915.015)"/>
        </g>
        <g id="Group_5818" transform="translate(800.494 909.982)">
          <path id="Path_6436" d="M807.585 912.207c-.014-.425-.029-.433-.051-.858-.031-.6-.312-1.132-.618-1.175a21.191 21.191 0 0 0-5.695 0c-.306.043-.587.574-.618 1.175q-.219 4.4 0 8.8c.031.6.312 1.132.618 1.175a21.191 21.191 0 0 0 5.695 0c.307-.043.588-.573.618-1.175.02-.407.037-.5.051-.9" class="cls-4" transform="translate(-800.494 -909.982)"/>
        </g>
      </g>
    </SvgIcon>
  );
}

export default LeaveIcon;


// WEBPACK FOOTER //
// ./src/components/icons/LeaveIcon.jsx